import { AdvancedHostingActionTypes } from './advancedHosting.types';

export const initialState = {
  list: {
    servers: [],
    pagination: {
      currentPage: 1,
      lastPage: 1,
      perPage: 10,
      total: 0,
    },
    lastListParams: {},
    loading: true,
    error: null,
  },
  updateServer: {
    loading: false,
    error: null,
  },
  serverStatus: {
    byId: {},
  },
};

const advancedHostingReducer = (state = initialState, action) => {
  switch (action.type) {
    case AdvancedHostingActionTypes.ADVANCED_HOSTING_SET_LAST_LIST_PARAMS:
      return {
        ...state,
        list: {
          ...state.list,
          lastListParams: action.payload,
        },
      };

    case AdvancedHostingActionTypes.ADVANCED_HOSTING_LIST_LOADING:
      return {
        ...state,
        list: {
          ...state.list,
          loading: action.payload,
          error: null,
        },
      };

    case AdvancedHostingActionTypes.ADVANCED_HOSTING_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          servers: action.payload.servers,
          pagination: action.payload.pagination,
          loading: false,
          error: null,
        },
      };

    case AdvancedHostingActionTypes.ADVANCED_HOSTING_LIST_FAILURE:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.payload,
        },
      };

    case AdvancedHostingActionTypes.ADVANCED_HOSTING_UPDATE_SERVER_LOADING:
      return {
        ...state,
        updateServer: {
          ...state.updateServer,
          loading: action.payload,
          error: null,
        },
      };

    case AdvancedHostingActionTypes.ADVANCED_HOSTING_UPDATE_SERVER_SUCCESS:
      return {
        ...state,
        updateServer: {
          ...state.updateServer,
          loading: false,
          error: null,
        },
      };

    case AdvancedHostingActionTypes.ADVANCED_HOSTING_UPDATE_SERVER_FAILURE:
      return {
        ...state,
        updateServer: {
          ...state.updateServer,
          loading: false,
          error: action.payload,
        },
      };

    case AdvancedHostingActionTypes.ADVANCED_HOSTING_SERVER_STATUS_LOADING: {
      const current = state.serverStatus.byId[action.payload.serverId];
      if (current?.loading === action.payload.loading) return state;
      return {
        ...state,
        serverStatus: {
          ...state.serverStatus,
          byId: {
            ...state.serverStatus.byId,
            [action.payload.serverId]: {
              ...current,
              loading: action.payload.loading,
            },
          },
        },
      };
    }

    case AdvancedHostingActionTypes.ADVANCED_HOSTING_SERVER_STATUS_SUCCESS:
      return {
        ...state,
        serverStatus: {
          ...state.serverStatus,
          byId: {
            ...state.serverStatus.byId,
            [action.payload.serverId]: {
              loading: false,
              status: action.payload.status,
              error: null,
            },
          },
        },
      };

    case AdvancedHostingActionTypes.ADVANCED_HOSTING_SERVER_STATUS_FAILURE:
      return {
        ...state,
        serverStatus: {
          ...state.serverStatus,
          byId: {
            ...state.serverStatus.byId,
            [action.payload.serverId]: {
              loading: false,
              status: null,
              error: action.payload.error,
            },
          },
        },
      };

    default:
      return state;
  }
};

export default advancedHostingReducer;
